import React from 'react';

const e = React.createElement;

const projects = [
  {
    id: 1,
    title: "Grind",
    platform: "Steam",
    description: "Shooter game mode with a mercenaries mode where you will finds 100's of zombies attacking on you",
    techStack: "Unreal Engine, C++"
  },
  {
    id: 2,
    title: "Path To Heaven",
    platform: "Android & IOS",
    description: "Cute Ghost game where you have to escape graveyard and save your self for entering new born baby",
    techStack: "Unity, C#"
  }
];

function Home() {
  return e('div', { className: 'page-content' },
    e('h1', null, 'Game Projects'),
    e('div', { className: 'portfolio-grid' },
      projects.map((project) => 
        e('div', { key: project.id, className: 'project-card' },
          e('h3', null, project.title),
          e('p', { className: 'platform' }, e('strong', null, 'Platform: '), project.platform),
          e('p', null, project.description),
          e('p', { className: 'tech' }, e('strong', null, 'Tools: '), project.techStack)
        )
      )
    )
  );
}

export default Home;